<template>
  <div class="report_wrap" ref="turtor">
    <div class="repost_mobile_shiying">
      <div class="report_img">
        <div class="img_tit">{{ title }}</div>
      </div>
      <div class="report_options">
        <el-row class="option" type="flex" justify="space-between">
          <el-col class="option_item" v-for="(item, index) in optionsList" :key="index"
            @click.native="changeOptionIndex(index)">
            <div class="item_top">
              <img :src="item.icon" alt="" />
            </div>
            <div class="item_bottom" :class="optionActive === index ? 'active' : ''">
              {{ item.txt }}
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="report_avtive_wrap" v-show="optionActive === 0">
        <div class="repost_tag_wrap hidden-xs-only">
          <span>热门标签：</span>
          <Tag color="blue" checkable :checked="tag.isSelect" size="large" v-for="(tag, index) in tagList" :key="index"
            :name="index" @on-change="changeSelectTag">{{ tag.txt }}</Tag>
        </div>
        <div class="book_list">
          <p class="hidden-xs-only" style="width: 60%; margin: 0 auto">
            共<span style="color: #2091d3; padding: 0 6px">{{
              this.newsListMap[activeIndex]?.length || 0
            }}</span>个行业报告
          </p>
          <Tabs :value="activeIndex + ''" class="tabs_wrap" draggable style="margin: 0 auto"
            @on-click="(name) => changeSelectTag(true, Number(name))">
            <TabPane :label="tag.txt" :name="String(index)" class="tabs_item" v-for="(tag, index) in tagList"
              :key="index">
              <div class="book_content">
                <div class="book_item" v-for="(item, index) in newsListMap[activeIndex] || []" :key="index">
                  <div class="book_left">
                    <img :src="item.image" alt="" />
                  </div>
                  <div class="book_right" @click="reportNavigate(item.url)">
                    <span class="hvr-grow">{{ item.title }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>

      <div class="report_avtive_wrap" v-show="optionActive === 1">
        <div class="book_list">
          <div class="new_title">
            <div style="font-size: 20px; text-align: center">
              <span>— 年报 —</span>
            </div>
            <div style="font-size: 16px; text-align: center">
              <span>ANNUAL REPORT</span>
            </div>
          </div>
          <Tabs :value="activeIndex2 + ''" class="tabs_wrap" draggable @on-click="tongBuTags" style=" margin: 0 auto">
            <TabPane :label="cardItem.txt" :name="String(cardIndex)" class="tabs_item"
              v-for="(cardItem, cardIndex) in tagList" :key="cardIndex">
            </TabPane>
          </Tabs>
          <div class="book_list_scroll" ref="listScroll">
            <el-row class="card_list">
              <el-col class="card_item" v-for="(item, index) in annulListMap[activeIndex2]" :key="index">
                <div class="big_box" @click="reportNavigate(item.url)">
                  <div class="item_left">
                    <img :src="item.image" alt="" />
                  </div>
                  <div class="item_right">
                    <h1>{{ item.title }}</h1>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- ---------------------------------------------------------------------分层辨认... -->
        <div class="book_list">
          <div class="new_title">
            <div style="font-size: 20px; text-align: center">
              <span>— 观察 —</span>
            </div>
            <div style="font-size: 16px; margin-bottom: 15px; text-align: center">
              <span>RESEARCH REPORT</span>
            </div>
          </div>
          <Tabs :value="activeIndex3 + ''" class="tabs_wrap" draggable @on-click="tongBuTags2" style=" margin: 0 auto">
            <TabPane :label="cardItem.txt" :name="String(cardIndex)" class="tabs_item"
              v-for="(cardItem, cardIndex) in tagList" :key="cardIndex">
            </TabPane>
          </Tabs>
          <div class="book_list_scroll" ref="listScroll2">
            <el-row class="card_list">
              <el-col class="card_item" v-for="(item, index) in researchListMap[activeIndex3]" :key="index">
                <div class="big_box" @click="reportNavigate(item.url)">
                  <div class="item_left">
                    <img :src="item.image" alt="" />
                  </div>
                  <div class="item_right">
                    <h1>{{ item.title }}</h1>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- ---------------------------------------------------------------------分层辨认... -->
        <div class="book_list">
          <div class="new_title">
            <div style="font-size: 20px; margin-top: 20px; text-align: center">
              <span>— 研究 —</span>
            </div>
            <div style="font-size: 16px; margin-bottom: 15px; text-align: center">
              <span>RESEARCH REPORT</span>
            </div>
          </div>
          <Tabs :value="activeIndex4 + ''" class="tabs_wrap" draggable @on-click="tongBuTags3" style=" margin: 0 auto">
            <TabPane :label="cardItem.txt" :name="String(cardIndex)" class="tabs_item"
              v-for="(cardItem, cardIndex) in tagList" :key="cardIndex">
            </TabPane>
          </Tabs>
          <div class="book_list_scroll" ref="listScroll3">
            <el-row class="card_list">
              <el-col class="card_item" v-for="(item, index) in research2ListMap[activeIndex4]" :key="index">
                <div class="big_box" @click="reportNavigate(item.url)">
                  <div class="item_left">
                    <img :src="item.image" alt="" />
                  </div>
                  <div class="item_right">
                    <h1>{{ item.title }}</h1>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- ---------------------------------------------------------------------分层辨认... -->
        <div class="book_list">
          <div class="new_title">
            <div style="font-size: 20px; margin-top: 20px; text-align: center">
              <span>— 数据 —</span>
            </div>
            <div style="font-size: 16px;text-align: center">
              <span>DATA</span>
            </div>
          </div>
          <Tabs :value="activeIndex5 + ''" class="tabs_wrap" draggable @on-click="tongBuTags4" style=" margin: 0 auto">
            <TabPane :label="cardItem.txt" :name="String(cardIndex)" class="tabs_item"
              v-for="(cardItem, cardIndex) in tagList" :key="cardIndex">
            </TabPane>
          </Tabs>
          <div class="book_list_scroll" ref="listScroll4">
            <el-row class="card_list">
              <el-col class="card_item" v-for="(item, index) in dataListMap[activeIndex5]" :key="index">
                <div class="big_box" @click="reportNavigate(item.url)">
                  <div class="item_left">
                    <img :src="item.image" alt="" />
                  </div>
                  <div class="item_right">
                    <h1>{{ item.title }}</h1>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="new_title">
          <div style="font-size: 20px; margin-top: 20px; text-align: center">
            <span>— 视频 —</span>
          </div>
          <div style="font-size: 16px; margin-bottom: 15px; text-align: center">
            <span>VIDEO</span>
          </div>
        </div>
        <el-row class="video_column" type="flex">
          <el-col :span="4" :xs="12" v-for="(item, index) in videoList" :key="index" class="video_item">
            <el-card :body-style="{ padding: '0px' }" @click.native="videoNavigate(item.url)">
              <img :src="item.image" class="image" />
              <div class="video_content">
                <h1>{{ item.title }}</h1>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div class="list_scroll_btn" style="text-align: center; margin-top: 30px">
        </div>
      </div>
      <!-- 媒体报道 - 完善后与行业报告一致的布局 -->
      <div class="report_avtive_wrap" v-show="optionActive === 2">
        <div class="repost_tag_wrap hidden-xs-only">
          <span>热门标签：</span>
          <Tag color="blue" checkable :checked="tag.isSelect" size="large" v-for="(tag, index) in tagList" :key="index"
            :name="index" @on-change="changeSelectTagMedia">{{ tag.txt }}</Tag>
        </div>
        <div class="book_list">
          <p class="hidden-xs-only" style="width: 60%; margin: 0 auto">
            共<span style="color: #2091d3; padding: 0 6px">{{
              this.mediaListMap[activeMediaIndex]?.length || 0
            }}</span>篇媒体报道
          </p>
          <Tabs :value="activeMediaIndex + ''" class="tabs_wrap" draggable style="margin: 0 auto"
            @on-click="(name) => changeSelectTagMedia(true, Number(name))">
            <TabPane :label="tag.txt" :name="String(index)" class="tabs_item" v-for="(tag, index) in tagList"
              :key="index">
              <div class="book_content">
                <div class="book_item" v-for="(item, index) in mediaListMap[activeMediaIndex] || []" :key="index">
                  <div class="book_left">
                    <img :src="item.image || item.img" alt="" />
                  </div>
                  <div class="book_right" @click="handleNewsDetails(item.url)">
                    <span class="hvr-grow">{{ item.title }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import Pullup from '@better-scroll/pull-up'
import MouseWheel from '@better-scroll/mouse-wheel'
import { mapGetters } from 'vuex'
import { getNews, getNewsTags } from '../../api/news'
import { data } from 'vue-awesome'
BScroll.use(Pullup)
BScroll.use(MouseWheel)
export default {
  data() {
    return {
      title: '',
      optionsList: [
        {
          icon: require('@/assets/img/63.png'),
          txt: '行业报告',
        },
        {
          icon: require('@/assets/img/64.png'),
          txt: '精选文章',
        },
        {
          icon: require('@/assets/img/65.png'),
          txt: '媒体报道',
        },
      ],
      optionActive: 0,
      tagList: [],
      tagList2: [
        {
          isSelect: true,
          txt: '全部',
        },
        {
          isSelect: false,
          txt: '招商月报',
        },
        {
          isSelect: false,
          txt: '热点解读',
        },
      ],
      activeIndex: 0,
      activeMediaIndex: 0, // 媒体报道的当前标签索引
      mediaList: [],
      mediaListMap: {}, // 按标签分类的媒体报道数据
      scroll: null,
      scroll2: null,
      scroll3: null,
      scroll4: null,
      timer: null,
      pageNo: 1,
      pageNoMedia: 1,
      total1: 0,
      total2: 0,
      activeIndex2: 0,
      activeIndex3: 0,
      activeIndex4: 0,
      activeIndex5: 0,
      columnList: [],
      videoList: [],
      newsListMap: {},
      annulListMap: {},
      researchListMap: {},
      research2ListMap: {},
      dataListMap: {},
      industryList: {},
      page: 0,
      size: 999
    }
  },
  created() {
    this.optionActive =
      this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
  },
  async mounted() {
    this.scroll = new BScroll(this.$refs.listScroll, {
      scrollX: true, //X轴滚动启用
      eventPassthrough: 'vertical',
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300,
      },
    })
    this.scroll2 = new BScroll(this.$refs.listScroll2, {
      scrollX: true, //X轴滚动启用
      eventPassthrough: 'vertical',
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300,
      },
    })
    this.scroll3 = new BScroll(this.$refs.listScroll3, {
      scrollX: true, //X轴滚动启用
      eventPassthrough: 'vertical',
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300,
      },
    })
    this.scroll4 = new BScroll(this.$refs.listScroll4, {
      scrollX: true, //X轴滚动启用
      eventPassthrough: 'vertical',
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300,
      },
    })

    await this.getNewsTagsFunc()
    this.getNewsFunc({ typeId: this.optionActive + 1 }, this.activeIndex) // 1行业报告 2精选文章 3媒体报道
  },
  methods: {
    clearPage() {
      this.page = 0
      this.size = 10
    },
    changeOptionIndex(index) {
      this.optionActive = index
      if (index === 1) {
        this.getAnnulNews()
        this.getResearchNews()
        this.getResearch2News()
        this.getDataNews()
        this.getIndustryNews()
        this.getVideoNews()
        this.$nextTick(() => {
          this.scroll.refresh()
          this.scroll2.refresh()
          this.scroll3.refresh()
          this.scroll4.refresh()
        })
      } else if (index === 2) {
        // 媒体报道
        this.getMediaListByTag(this.activeMediaIndex)
      }
    },
    changeSelectTag(checked, name) {
      this.clearPage()
      this.activeIndex = name
      this.tagList.map((v, i) => {
        if (name === i) {
          v.isSelect = checked
        } else {
          v.isSelect = false
        }
      })
      this.getNewsFunc({ typeId: this.optionActive + 1 }, this.activeIndex)
    },
    // 媒体报道标签切换
    changeSelectTagMedia(checked, name) {
      this.activeMediaIndex = name
      this.tagList.map((v, i) => {
        if (name === i) {
          v.isSelect = checked
        } else {
          v.isSelect = false
        }
      })
      this.getMediaListByTag(this.activeMediaIndex)
    },
    changeSelectTag2(checked, name) {
      this.activeIndex2 = name
      this.tagList2.map((v, i) => {
        if (name === i) {
          v.isSelect = checked
        } else {
          v.isSelect = false
        }
      })
    },
    tongBuTags(name) {
      this.activeIndex2 = name * 1
      this.scroll.scrollTo(0)
      this.getAnnulNews()
    },
    tongBuTags2(name) {
      this.activeIndex3 = name * 1
      this.scroll.scrollTo(0)
      this.getResearchNews()
    },
    tongBuTags3(name) {
      this.activeIndex4 = name * 1
      this.scroll.scrollTo(0)
      this.getResearch2News()
    },
    tongBuTags4(name) {
      this.activeIndex5 = name * 1
      this.scroll.scrollTo(0)
      this.getDataNews()
    },
    handleNewsDetails(url) {
      if (url) {
        window.open(url)
      }
    },
    reportNavigate(url) {
      if (url) {
        window.open(url)
      }
    },
    videoNavigate(url) {
      if (url) {
        window.open(url)
      }
    },
    showMoreForReport() {
      window.open('http://www.mtx.cn/#/search?type=0')
    },
    showColumn() {
      window.open('http://www.mtx.cn/#/search?type=2')
    },
    showVideo() {
      window.open('http://www.mtx.cn/#/videolist')
    },
    async getNewsTagsFunc() {
      const res = await getNewsTags()
      if (res.data) {
        this.tagList = res.data.data.reduce((pre, cur, i) => {
          pre.push({
            txt: cur.tagName,
            isSelect: i == 0,
            id: cur.id
          })
          return pre
        }, [])
      }
    },
    async getNewsFunc(params, index) {
      const res = await getNews({
        tagId: this.tagList[index].id,
        page: this.page,
        size: this.size,
        ...params,
      })
      if (res.data) {
        this.$set(this.newsListMap, index, res.data.data.content)
      }
    },
    getNewsCommonFunc(params) {
      return getNews({
        page: 0,
        size: 999,
        ...params,
      })
    },
    async getAnnulNews() {
      const res = await this.getNewsCommonFunc({
        typeId: 4, // 年报
        tagId: this.activeIndex2 + 1
      })
      this.$set(this.annulListMap, this.activeIndex2, res.data.data.content)
    },
    async getResearchNews() {
      const res = await this.getNewsCommonFunc({
        typeId: 5, // 观察
        tagId: this.activeIndex3 + 1
      })
      this.$set(this.researchListMap, this.activeIndex3, res.data.data.content)
    },
    async getResearch2News() {
      const res = await this.getNewsCommonFunc({
        typeId: 6, // 研究
        tagId: this.activeIndex4 + 1
      })
      this.$set(this.research2ListMap, this.activeIndex4, res.data.data.content)
    },
    async getDataNews() {
      const res = await this.getNewsCommonFunc({
        typeId: 7, // 数据
        tagId: this.activeIndex5 + 1
      })
      this.$set(this.dataListMap, this.activeIndex5, res.data.data.content)
    },
    async getIndustryNews() {
      const res = await this.getNewsCommonFunc({
        typeId: 8, // 专栏
      })
      this.industryList = res.data.data.content
    },
    async getVideoNews() {
      const res = await this.getNewsCommonFunc({
        typeId: 9, // 视频
      })
      this.videoList = res.data.data.content
    },
    async getMediaList() {
      const res = await this.getNewsCommonFunc({
        typeId: 3, // 媒体报道
      })
      this.mediaList = res.data.data.content
      // 初始化时将所有媒体报道分配到第一个标签（全部）
      this.$set(this.mediaListMap, 0, this.mediaList)
    },
    // 根据标签获取媒体报道
    async getMediaListByTag(index) {
      const res = await this.getNewsCommonFunc({
        typeId: 3, // 媒体报道
        tagId: this.tagList[index]?.id
      })
      if (res.data) {
        this.$set(this.mediaListMap, index, res.data.data.content)
      }
    },
  },
  watch: {
    $route() {
      this.optionActive =
        this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    },
    menuList: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.title = newVal.find(v => v.routePath === '/fournav').menuName
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['getMenuList']),
    menuList() {
      return this.getMenuList
    }
  },
}
</script>


<style lang="scss">
.report_wrap {

  .repost_mobile_shiying {
    @media screen and (max-width: 768px) {}

    .report_img {
      width: 100%;
      height: 600px;

      @media screen and (max-width: 768px) {
        height: 50vw;
      }

      background: url('../../assets/img/newbg.22e89fc.jpg') 0 0 no-repeat;
      background-size: 100% 100%;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;

      .img_tit {
        font-size: 60px;
        font-weight: bold;

        @media screen and (max-width: 768px) {
          font-size: 1.2rem;
        }
      }
    }

    .report_options {
      width: 100%;
      height: 120px;
      box-shadow: 0px 5px 5px rgba($color: #000000, $alpha: 0.1);

      @media screen and (max-width: 768px) {
        height: 105px;
        display: flex;
      }

      .option {
        width: 70%;
        margin: 0 auto;
        align-items: center;

        @media screen and (max-width: 768px) {
          width: 90%;
        }

        .option_item {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          cursor: pointer;

          .item_top {
            width: 15%;
            margin-top: 10px;

            @media screen and (max-width: 768px) {
              width: 30%;
            }

            img {
              width: 100%;
            }
          }

          .item_bottom {
            margin-left: 5px;
            font-weight: bold;
            font-size: 20px;

            @media screen and (max-width: 768px) {
              font-size: 14px;
            }
          }

          .active {
            color: #2091d3;
          }
        }
      }
    }

    .repost_tag_wrap {
      width: 60%;
      height: 100px;
      background: #f4f9fc;
      margin: 50px auto;
      display: flex;
      align-items: center;
      padding: 0 30px;

      span {
        color: #8a989c;
        font-size: 18px;
      }
    }

    .book_list {
      @media screen and (max-width:768px) {
        height: 470px;
      }

      .new_title {
        @media screen and (min-width:768px) {
          margin-top: 30px;
        }

        &:nth-child(n+2) {
          margin-top: 60px;
        }

        @media screen and (max-width: 768px) {
          padding-top: 15px;
        }
      }

      @media screen and (max-width: 768px) {
        width: 100%;
        padding: 0 20px;
        background: #f4f9fc;
      }

      .book_list_scroll {
        width: 1500px;
        margin: 0 auto;
        overflow: hidden;

        @media screen and (max-width:768px) {
          width: 100%;
        }

        .card_list {
          width: 3400px;

          @media screen and (max-width:768px) {
            width: 2000px;
            margin-top: 30px;
          }

          .card_item {
            @media screen and (max-width:768px) {
              width: 200px;
              height: 200px;
            }

            float: left;
            width: 300px;
            text-align: center;

            &:hover {
              transform: scale(1);
              box-shadow: none;
            }

            .big_box {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              @media screen and (max-width:768px) {
                height: 100%;
              }

              .item_left {
                width: 300px;
                text-align: center;
                user-select: none;

                @media screen and (max-width:768px) {
                  width: 100%;
                  height: 100%;
                }

                img {
                  transition: all .6s;
                  width: 80%;
                  min-height: 300px;
                  margin-left: 20px;
                  border: solid 1px rgb(235, 235, 235);

                  &:hover {
                    box-shadow: 0 0 20px rgba($color: #000000, $alpha: .1);
                  }

                  @media screen and (max-width:768px) {
                    max-height: 300px;
                  }
                }
              }

              .item_right {
                padding: 10px 20px !important;

                h1 {
                  font-size: 0.8rem !important;
                  font-weight: 400;
                  text-align: center;
                  white-space: normal;

                  @media screen and (max-width:768px) {
                    font-size: 14px !important;
                  }
                }
              }
            }
          }
        }

        .list_scroll_btn {
          text-align: center;

          .scroll_btn {
            background: #FFA400;
            color: #fff;
            font-size: 14PX;
            border-radius: 15PX;

            @media screen and (max-width:768px) {
              width: 80px;
              height: 35px;
              margin-top: 40px;
            }
          }
        }
      }

      .book_content {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        @media screen and (max-width: 768px) {
          width: 100%;
        }

        .book_item {
          width: 45%;
          display: flex;

          @media screen and (max-width: 768px) {
            width: 100%;
            background: #fff;
            margin-top: 20px;
            margin: 10px auto;
            padding: 10px;
          }

          &:nth-child(n + 3) {
            margin-top: 20px;
          }

          .book_left {
            width: 50%;
            margin-right: 40px;

            @media screen and (max-width: 768px) {
              width: 40%;
            }

            img {
              width: 100%;
            }
          }

          .book_right {
            font-weight: bold;
            font-size: 20px;

            span {
              cursor: pointer;
            }

            @media screen and (max-width: 768px) {
              font-size: 16px;
              color: #000;
            }
          }
        }
      }

      .tabs_wrap {
        width: 60%;

        @media screen and (max-width:768px) {
          width: 100%;
        }

        padding-top: 1rem;
      }
    }
  }

  .ivu-tabs-tab {
    font-size: 1rem !important;
    height: 2rem !important;
  }

  .card_list {
    flex-wrap: wrap;

    .card_item {
      display: flex;
      margin-top: 1rem;
      padding: 20px;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        box-shadow: 10px 10px 20px rgba($color: #000000, $alpha: 0.2);
        transform: scale(1.05);
      }

      .item_left {
        flex: 1;

        img {
          width: 90%;
          height: 100%;
          max-height: 350px;
          object-fit: cover;
          -webkit-user-drag: none;
        }
      }

      .item_right {
        flex: 1;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        h1 {
          color: #666;
          font-size: 28px;

          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        p {
          font-size: 13px;

          @media screen and (max-width: 768px) {
            &:nth-child(2) {
              display: none;
            }

            font-size: 13px;
          }
        }
      }
    }
  }
}

.zhuan_column {
  width: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-evenly;

  img {
    width: 100%;
  }

  .zhuan_item {
    @media screen and (max-width:768px) {
      &:nth-child(n+3) {
        margin-top: 10px;
      }
    }

    .zhuan_content {
      padding: 14px;

      @media screen and (max-width:768px) {
        pad: 10px;
      }

      h1 {
        min-height: 80px;
        color: #FFA400;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 1.1rem;

        @media screen and (max-width:768px) {
          min-height: 55px;
        }
      }

      .btn {
        background: #FFA400;
        float: right;
        color: #fff;
        margin-top: 20px;
        width: 80PX;
        height: 35PX;
        border-radius: 20PX;

        @media screen and (max-width:768px) {
          font-size: 12px;
        }
      }

      .details {
        color: #999;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;

        @media screen and (max-width:768px) {
          font-size: 13px;
        }
      }

      .desc {
        color: #666;
        min-height: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin: 10px 0;

        @media screen and (max-width:768px) {
          font-size: 13px;
        }
      }
    }
  }
}

.video_column {
  width: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-evenly;

  .video_item {
    .video_content {
      cursor: pointer;
      padding: 14px;

      h1 {
        color: #666;
        font-size: 0.9rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;

        @media screen and (max-width:768px) {
          min-height: 65px;
        }
      }
    }

    img {
      width: 100%;
      min-height: 180px;
      cursor: pointer;

      @media screen and (max-width:768px) {
        min-height: 106px;
      }
    }
  }
}

.book_list_speial {
  padding-top: 16px;
  width: 70%;
  margin: 0 auto;
}

.scroll_btn2 {
  @media screen and (max-width:768px) {
    width: 280px;
    height: 35px;
    background: #fff !important;
    color: #FFA400 !important;
    border: solid 1px #FFA400 !important;
    font-size: 12px;
  }
}
</style>